// Picks white or black collection titles based on the brightness of the
// image region behind the title. Falls back to the CSS default (white) if the
// canvas can't be read (CORS/taint).
(function () {
  // ponytail: luminance cutoff 0-255. Raise if light images still get white text, lower if dark images get black.
  const THRESHOLD = 140;

  function apply(card) {
    const img = card.querySelector('.card__media img');
    if (!img) return;
    const run = () => {
      try {
        const cv = document.createElement('canvas');
        cv.width = cv.height = 32;
        const ctx = cv.getContext('2d', { willReadFrequently: true });
        const sy = Math.round(img.naturalHeight * 0.6); // bottom band, where the title sits
        ctx.drawImage(img, 0, sy, img.naturalWidth, img.naturalHeight - sy, 0, 0, 32, 32);
        const d = ctx.getImageData(0, 0, 32, 32).data;
        let sum = 0;
        for (let i = 0; i < d.length; i += 4) {
          sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
        }
        card.classList.toggle('card--light-bg', sum / (d.length / 4) > THRESHOLD);
      } catch (e) {
        /* tainted canvas — keep default */
      }
    };
    if (img.complete && img.naturalWidth) run();
    else img.addEventListener('load', run, { once: true });
  }

  function init(root) {
    (root || document).querySelectorAll('.collection-list-wrapper .card').forEach(apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target)); // theme editor re-render
})();
